//src/pages/admin/AdminTickets.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { Link } from "react-router-dom";

export default function AdminTickets() {
  const [tickets, setTickets] = useState([]);
  const [status, setStatus] = useState("all");

  const load = async () => {
    const res = await api.get("/admin/tickets", {
      params: status === "all" ? {} : { status },
    });
    setTickets(res.data || []);
  };

  useEffect(() => {
    load();
  }, [status]);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Support Tickets</h1>

      <select
        className="input-glass max-w-xs bg-[#0b0f17] text-white"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="all">All</option>
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </select>

      <table className="table-glass">
        <thead>
          <tr>
            <th>User</th>
            <th>Subject</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {tickets.length === 0 ? (
            <tr>
              <td colSpan="3" className="text-center py-6 text-gray-400">
                No tickets
              </td>
            </tr>
          ) : (
            tickets.map(t => (
              <tr key={t._id}>
                <td>{t.user?.email}</td>
                <td>
                  <Link
                    to={`/admin/tickets/${t._id}`}
                    className="text-purple-400 hover:underline"
                  >
                    {t.subject}
                  </Link>
                </td>
                <td>
                  <span className={`chip chip-${t.status}`}>
                    {t.status}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
